import GeneralTranslations from "../../../Common/ModuleTranslations/fr";
import CONSTANTS from "../../constants";

function formTypeHelperText({ formValues }) {
  switch (formValues.type) {
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_CONFIRMATION:
      return "Envoyé lorsque l'utilisateur effectue une réservation. Il ne peut y avoir qu'un seul modèle actif à la fois.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.RESERVATION_STATUS_RED:
      return "Envoyé lorsque le paiement de la réservation échoue.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.POST_STAY:
      return "Sera envoyé quelques jours après l'arrivée du client.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PRE_STAY:
      return "Sera envoyé quelques jours avant le séjour du client.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.CART_ABANDONMENT:
      return "<div><strong style='color:red;'>Pour activer l'abandon de panier, VOUS DEVEZ contacter le Support.</strong><br/>L'email sera envoyé si le client avait au moins une réservation dans son panier.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.GIFT_CARD:
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.PURCHASE_EVENT:
      return "";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.UPSELL_AVAILABLE:
      return "<div><strong style='color:red;'>Pour activer la fonctionnalité « Surclassement », vous DEVEZ contacter le Support.</strong><br/>L'e-mail sera envoyé si le client a effectué une réservation correspondant à la configuration des règles de l'Upgrade.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.QUOTATION_PRICE:
      return "<div><strong style='color:red;'>Pour activer le « Calculateur de prix », vous DEVEZ contacter le Support.</strong><br/>L'e-mail sera envoyé lorsqu'un devis sera créé et envoyé.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.WAITING_LIST_AVAILABLE:
      return "L'e-mail sera envoyé lorsque l'hôtel disposera de disponibilités.";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.LOYALTY_WELCOME:
      return "<div><strong style='color:red;'>Pour activer l'e-mail « Bienvenue Loyalty », vous devez avoir la fonctionnalité de fidélisation activée dans le moteur.</strong><br/>L'e-mail sera envoyé lorsqu'un utilisateur non fidélisé s'inscrit.</div>";
    case CONSTANTS.ENTITY.EMAIL_TEMPLATE.TYPES.LOYALTY_WELCOME_VALIDATED:
      return "<div><strong style='color:red;'>Pour activer l'e-mail « Agences », vous devez avoir la fonctionnalité de fidélisation activée dans le moteur.</strong><br/>L'e-mail sera envoyé lorsqu'une nouvelle agence s'inscrit.</div>";
    default:
      return "";
  }
}

export default {
  locale: "fr",
  name: "Modèles d'email",
  translation: {
    displayName: "Traductions",
  },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        displayName: "Actif",
      },
      {
        fieldName: "type",
        displayName: "Type d'email",
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Destinataires",
      },
      {
        fieldName: "preferred",
        displayName: "Par défaut",
      },
      {
        fieldName: "motors",
        displayName: "Moteurs",
      },
      {
        fieldName: "uso",
        displayName: "Usage",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "hotelTicker",
        displayName: "Code de l'hôtel",
      },
      {
        fieldName: "isActive",
        displayName: "Actif",
      },
      {
        fieldName: "preferred",
        description: "Marquer par défaut",
      },
      {
        fieldName: "preferredInactiveHint",
        value: "Seuls les modèles actifs peuvent être définis par défaut.",
      },
      {
        fieldName: "type",
        displayName: "Type d'email",
        optionDisplay: {
          RESERVATION_CONFIRMATION: {
            label: "Confirmation de réservation",
          },
          RESERVATION_STATUS_RED: {
            label: "Paiement échoué",
          },
          GIFT_CARD: {
            label: "Carte cadeau (avec séjour)",
          },
          PURCHASE_EVENT: {
            label: "Carte cadeau (sans séjour)",
          },
          POST_STAY: {
            label: "Après-séjour",
          },
          PRE_STAY: {
            label: "Pré-séjour",
          },
          CART_ABANDONMENT: {
            label: "Abandon de panier",
          },
          WAITING_LIST_AVAILABLE: {
            label: "Liste d'attente",
          },
          UPSELL_AVAILABLE: {
            label: "Surclassement",
          },
        },
        transform: ({ field, userInfo, formValues }) => {
          const isWitAdmin = userInfo?.isWitAdmin;
          const extraOptions = isWitAdmin
            ? {
                RESERVATION_STATUS_ORANGE: {
                  label: "Processus de paiement abandonné",
                },
              }
            : {};
          return {
            ...field,
            optionDisplay: { ...field.optionDisplay, ...extraOptions },
            className: "negativeMargin",
            helpText: formTypeHelperText({ formValues }),
          };
        },
      },
      {
        fieldName: "templateType",
        displayName: "Type de modèle",
        optionDisplay: {
          DEFAULT: {
            label: "Modèle par défaut",
          },
          CUSTOM: {
            label: "Modèle personnalisé",
          },
        },
      },
      {
        fieldName: "singleMailOnMultipleRoomStays",
        description:
          "Pour les réservations multiples, regrouper les confirmations dans un seul email (Visible uniquement pour WIT)",
      },
      {
        fieldName: "delay",
        displayName: "Délai",
        optionDisplay: {
          5: {
            label: "5 minutes",
          },
          10: {
            label: "10 minutes",
          },
          15: {
            label: "15 minutes",
          },
          30: {
            label: "30 minutes",
          },
          45: {
            label: "45 minutes",
          },
          60: {
            label: "60 minutes",
          },
        },
        helpText: "Nombre de minutes avant l'envoi d'un email.",
      },
      {
        fieldName: "delayCartAbandonment",
        displayName: "Délai",
        optionDisplay: {
          60: {
            label: "1 heure",
          },
          120: {
            label: "2 heures",
          },
          180: {
            label: "3 heures",
          },
          360: {
            label: "6 heures",
          },
          720: {
            label: "12 heures",
          },
          1440: {
            label: "24 heures",
          },
          2880: {
            label: "48 heures",
          },
        },
        helpText: "Temps après un abandon de panier avant que l'email soit envoyé.",
      },
      {
        fieldName: "delayCheckout",
        displayName: "Nombre de jours après le départ pour l'envoi",
      },
      {
        fieldName: "delayCheckin",
        displayName: "Nombre de jours avant l'arrivée pour l'envoi",
      },
      {
        fieldName: "chronoUnit",
        displayName: "Unités de délai",
        optionDisplay: {
          MINUTES: {
            label: "Minutes",
          },
          HOURS: {
            label: "Heures",
          },
          DAYS: {
            label: "Jours",
          },
        },
      },
      {
        fieldName: "emailDestinationType",
        displayName: "Destinataires",
        optionDisplay: {
          ALL: {
            label: "Tous",
          },
          GUEST: {
            label: "Client",
          },
          PROPERTY: {
            label: "Établissement",
          },
        },
      },
      {
        fieldName: "emailGuestType",
        displayName: "Type de client destinataire",
        optionDisplay: {
          ALL: {
            label: "Tous",
          },
          LOYALTY_GUEST: {
            label: "Client fidélité",
          },
          NON_LOYALTY_GUEST: {
            label: "Client non fidélité",
          },
        },
      },
      {
        fieldName: "subject",
        displayName: "Sujet",
      },
      {
        fieldName: "body",
        displayName: "Corps",
      },
      {
        fieldName: "header",
        displayName: "En-tête",
      },
      {
        fieldName: "footer",
        displayName: "Pied de page",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Sélection de propriétés",
      },
    ],
  },
};
